import { apiClient } from './apiClient';

/**
 * Controles opcionales por organización — no todos los clientes los
 * necesitan. Nuevos controles se agregan aquí como un campo más.
 */
export interface ConfiguracionOrganizacion {
  combustible_habilitado: boolean;
  ordenes_carga_habilitado: boolean;
}

/**
 * Identidad visual (nombre + logo) de la organización — se usa en el PDF de
 * la orden de carga y en la página pública de verificación por QR.
 */
export interface OrganizacionBranding {
  nombre_empresa: string;
  tiene_logo: boolean;
}

class ConfiguracionService {
  async obtener(): Promise<ConfiguracionOrganizacion> {
    const response = await apiClient.get<ConfiguracionOrganizacion>('/configuracion/organizacion');
    return response.data;
  }

  async actualizar(datos: Partial<ConfiguracionOrganizacion>): Promise<ConfiguracionOrganizacion> {
    const response = await apiClient.put<ConfiguracionOrganizacion>('/configuracion/organizacion', datos);
    return response.data;
  }

  async obtenerBranding(): Promise<OrganizacionBranding> {
    const response = await apiClient.get<OrganizacionBranding>('/configuracion/organizacion/branding');
    return response.data;
  }

  async actualizarBranding(nombreEmpresa: string, logo: File): Promise<OrganizacionBranding> {
    const formData = new FormData();
    formData.append('nombre_empresa', nombreEmpresa);
    formData.append('logo', logo);

    const response = await apiClient.post<OrganizacionBranding>(
      '/configuracion/organizacion/branding',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  }
}

export const configuracionService = new ConfiguracionService();
export default configuracionService;
